import React, { useState } from 'react';
import { CheckCircle, Cancel } from '@material-ui/icons';
import DeleteDialog from './DeleteDialog';
import './Selections.css';
/**
 * @Description This function returns Selections component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Selections ({ step, setStep, state, setState }) {
    const [open, setOpen] = useState(false);
    const handleClick = (item) => {
        let index = state[step].indexOf(item), newstep = 0;
        if (index < 0) { state[step].push(item); }
        else if (index > -1) {
            state[step].splice(index, 1);
            if (step === 'category') {
                if (state['category'].length > 0) { newstep = 1; }
                state['source_app'] = [];
                state['destination_app'] = [];
            } else if (step === 'source_app') {
                if (state['source_app'].length > 0) { newstep = 2; }
                else { newstep = 1; }
                state['destination_app'] = [];
            } else if (step === 'destination_app') {
                if (state['destination_app'].length > 0) { newstep = 3; }
                else { newstep = 2; }
            }
            state['variant'] = { first: [], second: [] };
        }
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
        setStep(newstep);
    };
    const getStyle = (itemI) => {
        if (state[step].length % 2 === 1 && state[step].length - 1 === itemI) {
            return { width: 300, textAlign: 'center' };
        } else if (itemI % 2 === 0) {
            return { textAlign: 'right' };
        }
    };
    return (
        <div className="vselections">
            {state[step].map((item, itemI) => {
                return (
                    <div key={itemI} style={getStyle(itemI)}>
                        <button className="vseleciton" onClick={() => setOpen(item)}>
                            <span><CheckCircle fontSize="small" />{item.name}</span>
                            <span><Cancel fontSize="small" /></span>
                        </button>
                    </div>
                );
            })}
            {open && <DeleteDialog open={open} setOpen={setOpen} onDelete={handleClick} />}
        </div>
    );
}
export default Selections;